import { StagingBucketsApi, type Configuration } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const stagingBuckets = (
  httpClient: HttpClient,
  config: Configuration,
  projectId: string
) => {
  const api = new StagingBucketsApi(config);
  return {
    useList: (enabled = true) =>
      httpClient.execute(
        api.listStagingBuckets.bind(api),
        enabled ? '/staging-buckets' : null,
        '/staging-buckets',
        projectId
      ),
  };
};
